module.exports = __webpack_public_path__ + "static/media/footer_logo.254f0082.svg";